import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CheckoutState, initCheckout } from './CheckoutReducer';

export const selectCheckoutState = createFeatureSelector<CheckoutState>('checkout');

export const initCheckoutSelector = createSelector(
  selectCheckoutState,
  initCheckout
);
